import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import dashboardIcon from "../../assets/icons/grid.svg";
import downloadIcon from "../../assets/icons/download.svg";
import favoritesIcon from "../../assets/icons/move-menu/add-favorites.svg";
import logoutIcon from "../../assets/icons/logout-red.svg";
import { Link } from "react-router-dom";

const AvatarDropdown = forwardRef(({ onLogout, onClose }, ref) => {
  const user = useSelector((state) => state.auth.user);

  const displayName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.firstName || user?.lastName || "User";

  const displayEmail = user?.email || "No email available";

  return (
    <div
      ref={ref}
      className="absolute right-0 top-full mt-2 
                 w-[200px] sm:w-[248px] 
                 bg-[#111111] rounded-[10px] sm:rounded-[15px] 
                 shadow-[0px_16px_42.5px_rgba(0,0,0,0.25)] 
                 p-1 sm:p-2 
                 flex flex-col gap-[12px] sm:gap-[26px] 
                 z-[5999] transition-all duration-300"
    >
      {/* User Info Section */}
      <div className="flex items-center gap-1 sm:gap-2 
                      px-1 sm:px-2 
                      border-b border-[#2A2A2A] 
                      pb-1 sm:pb-2">
        <div className="flex flex-col">
          <span className="text-white font-bold 
                          text-[14px] sm:text-[16px] 
                          leading-[16px] sm:leading-[19px] 
                          -tracking-wide">
            {displayName}
          </span>
          <span className="mt-0.5 sm:mt-1 
                          text-[#828282] 
                          text-[10px] sm:text-xs 
                          leading-[12px] sm:leading-[14px]">
            {displayEmail}
          </span>
        </div>
      </div>

      {/* Menu Items Section */}
      <div className="flex flex-col gap-[6px] sm:gap-[12px] 
                      px-1 sm:px-2">
        <Link
          to="/subscription"
          className="flex items-center gap-2 sm:gap-3 
                     p-[4px] sm:p-[10px] 
                     w-full rounded-[6px] sm:rounded-[8px] 
                     text-white hover:bg-[#292929] 
                     transition-all duration-300
                     text-[14px] sm:text-[16px]"
        >
          <img
            src={dashboardIcon}
            alt="Dashboard"
            className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
          />
          Dashboard
        </Link>

        <Link
          to="/downloads"
          onClick={onClose}
          className="flex items-center gap-2 sm:gap-3 
                     p-[4px] sm:p-[10px] 
                     w-full rounded-[6px] sm:rounded-[8px] 
                     hover:bg-[#292929] text-white 
                     transition-all duration-300
                     text-[14px] sm:text-[16px]"
        >
          <img
            src={downloadIcon}
            alt="Download"
            className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
          />
          Download
        </Link>

        <Link
          to="/favorites"
          onClick={onClose}
          className="flex items-center gap-2 sm:gap-3 
                     p-[4px] sm:p-[10px] 
                     w-full rounded-[6px] sm:rounded-[8px] 
                     hover:bg-[#292929] text-white 
                     transition-all duration-300
                     text-[14px] sm:text-[16px]"
        >
          <img
            src={favoritesIcon}
            alt="Favorites"
            className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
          />
          Favorites
        </Link>

        {/* Logout Section */}
        <div className="p-[1px] mt-1 sm:mt-4 mb-0.5 sm:mb-2 
                        w-full rounded-[10px] sm:rounded-[12px] 
                        bg-[linear-gradient(90deg,_#1D1D1D,_#4B4949)]">
          <button
            onClick={onLogout}
            className="flex items-center gap-2 sm:gap-3 
                       w-full h-[28px] sm:h-[39px] 
                       px-1 sm:px-2 py-[4px] sm:py-[10px] 
                       rounded-[10px] sm:rounded-[12px] 
                       text-[#FF543E] bg-[#111] hover:bg-[#292929] 
                       transition-all duration-300
                       text-[14px] sm:text-[16px]"
          >
            <img 
              src={logoutIcon} 
              alt="Logout" 
              className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]" 
            />
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
});

export default AvatarDropdown;